import { LogicalFieldMixin } from './mixins.js';

const LogicalTextArea = {
  mixins: [LogicalFieldMixin],

  template: `
    <div class="form-field-input">
      <textarea placeholder='请输入' readonly></textarea>
    </div>
  `
};

export default LogicalTextArea;
